exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframe[data-v-82fbb014]{height:99.5vh}\n", ""]);

// exports
